import { Connection } from '@models/api/friends';
import { User } from '@models/user';

export const friendList: User[] = [
  {
    id: 1,
    profile_pic: '#04FC0D',
    profile_image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQL-L1UhpS9glJRsLpcu8L2COL88RL9e_JIZw&usqp=CAU',
    username: 'test1',
    url: 'http://localhost:8000/api/user/profile/test1/',
    bio: 'test1',
    pronouns: 'test1',
    user_personas: ['#lurker'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
  {
    id: 2,
    profile_pic: '#04FC0D',
    profile_image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS_9HpUdedwvWvuX-EdPNWGWQVOIcYIuI43ouVcm8O6h6_yB-bN8uPt2NyXuyPjd4mDgGk&usqp=CAU',
    username: 'test2',
    url: 'http://localhost:8000/api/user/profile/test2/',
    bio: 'test2',
    pronouns: 'test2',
    user_personas: ['#content_creator'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
  {
    id: 3,
    profile_pic: '#04FC0D',
    profile_image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSNys7iFvBBxifr5E1pgSgnlKxZ8G9HO-47sSR1oW57o1QAXA3YuXsmpVq1WZk9-HkoZls&usqp=CAU',
    username: 'test3',
    url: 'http://localhost:8000/api/user/profile/test3/',
    bio: 'test3',
    pronouns: 'test3',
    user_personas: ['#private_reactor'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
  {
    id: 4,
    profile_pic: '#04FC0D',
    profile_image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRUDvF8l753KHOWjwCmjEO1PfxYe5J95T54IA&usqp=CAU',
    username: 'test4',
    url: 'http://localhost:8000/api/user/profile/test4/',
    bio: 'test4',
    pronouns: 'test4',
    user_personas: ['#public_commenter'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
  {
    id: 5,
    profile_pic: '#04FC0D',
    profile_image: '',
    username: 'test5',
    url: 'http://localhost:8000/api/user/profile/test5/',
    bio: 'test5',
    pronouns: 'test5',
    user_personas: ['#instant_responder'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
  {
    id: 6,
    profile_pic: '#04FC0D',
    profile_image: '',
    username: 'test6',
    url: 'http://localhost:8000/api/user/profile/test6/',
    bio: 'test6',
    pronouns: 'test6',
    user_personas: ['#takes_my_time'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
  {
    id: 7,
    profile_pic: '#04FC0D',
    profile_image: '',
    username: 'test7',
    url: 'http://localhost:8000/api/user/profile/test7/',
    bio: 'test7',
    pronouns: 'test7',
    user_personas: ['#daily_scroller'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
  {
    id: 8,
    profile_pic: '#04FC0D',
    profile_image: '',
    username: 'test8',
    url: 'http://localhost:8000/api/user/profile/test8/',
    bio: 'test8',
    pronouns: 'test8',
    user_personas: ['#occasional_checker'],
    user_interests: ['#hiking', '#dogs'],
    connection_status: Connection.FRIEND,
  },
];
